import { memo } from 'react'
import { cn } from '@/lib/utils'

const ApprovalChangeTooltip = memo(
    ({ type, action, userTime, adAccountTime, originIcon: OriginIcon, actionIcon: ActionIcon }) => {
        // Determine approval status
        const isApproved = type === 'ad_approved'
        const originLabel =
            action.origin === 'meta'
                ? 'Meta Platform'
                : action.origin === 'system'
                  ? 'Turba App'
                  : action.actor_name || 'Manual Action'

        return (
            <div className={cn('tw:flex tw:flex-col tw:gap-6 tw:w-[290px] tw:box-border', 'tw:bg-[#071727]')}>
                <div className="tw:flex tw:items-start tw:justify-between tw:gap-4">
                    <div className="tw:flex tw:items-center tw:gap-3">
                        <div className="tw:relative tw:cursor-help tw:inline-block">
                            <ActionIcon size={27} />
                            {/* Origin indicator positioned at bottom-right corner */}
                            <div className="tw:absolute tw:bottom-0 tw:right-0 tw:translate-x-1/4 tw:translate-y-1/4">
                                <OriginIcon size={10} />
                            </div>
                        </div>
                        <div className="tw:flex tw:flex-col tw:gap-1">
                            <div className="tw:flex tw:items-center tw:gap-2">
                                <span className="tw:text-sm tw:font-medium tw:text-white">
                                    Ad{' '}
                                    <span className={cn(isApproved ? 'tw:text-[#4DD15E]' : 'tw:text-[#E0295E]')}>
                                        {isApproved ? 'approved' : 'declined'}
                                    </span>{' '}
                                    by {originLabel}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="tw:flex tw:justify-between">
                    <div className="tw:flex tw:flex-col tw:gap-1">
                        <span className="tw:text-sm tw:font-semibold">User Time</span>
                        <span className="tw:text-sm">{userTime}</span>
                    </div>
                    <div className="tw:flex tw:flex-col tw:gap-1">
                        <span className="tw:text-sm tw:font-semibold">Ad Account Time</span>
                        <span className="tw:text-sm">{adAccountTime}</span>
                    </div>
                </div>
            </div>
        )
    },
)

ApprovalChangeTooltip.displayName = 'ApprovalChangeTooltip'

export default ApprovalChangeTooltip
